import React, { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

const Home = () => {
  const scrollToAbout = () => {
    document.getElementById("about").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="home">
      {/* Mesh Gradient Background Animé */}
      <div className="mesh-gradient"></div>

      <div className="home__content">
        {/* Titre principal avec gradient animé */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >
            Cheffe de projet{" "}
            <span className="highlight-animated">Intelligence Artificielle</span>
          </motion.h1>

          <motion.p
            className="tech-stack"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          >
            Cadrage · Automatisation · Solutions IA
          </motion.p>
        </motion.div>

        {/* Sous-titre */}
        <motion.p
          className="subtitle"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
        >
          J'aide à structurer des problématiques métier et à identifier des usages pertinents de l'IA, afin de concevoir des solutions concrètes, utiles et rapidement exploitables.
        </motion.p>

        {/* Quick Stats */}
        <motion.div
          className="quick-stats"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <span className="stat">Lyon · France</span>
          <span className="stat-divider">•</span>
          <span className="stat">Alternance · Cheffe de projet IA</span>
          <span className="stat-divider">•</span>
          <span className="stat">Français · Espagnol · Anglais (pro)</span>
        </motion.div>

        {/* CTA Buttons avec effet magnétique */}
        <motion.div
          className="cta-buttons"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9, ease: "easeOut" }}
        >
          <MagneticButton href="#projects" primary>
            Voir mes projets
            <FaArrowRight className="btn-icon" />
          </MagneticButton>
          <MagneticButton href="#contact">Contact</MagneticButton>
        </motion.div>

        {/* Scroll indicator moderne (mouse scroll) */}
        <motion.div
          className="scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.5 }}
          onClick={scrollToAbout}
        >
          <div className="mouse-scroll">
            <div className="mouse">
              <motion.div
                className="wheel"
                animate={{ y: [0, 6, 0] }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />
            </div>
          </div>
          <span>Découvrir</span>
        </motion.div>
      </div>
    </section>
  );
};

// Composant Bouton Magnétique
const MagneticButton = ({ children, href, primary }) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const springConfig = { damping: 15, stiffness: 150 };
  const springX = useSpring(x, springConfig);
  const springY = useSpring(y, springConfig);

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    x.set((e.clientX - centerX) * 0.3);
    y.set((e.clientY - centerY) * 0.3);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.a
      ref={ref}
      href={href}
      className={`btn ${primary ? "btn-primary" : "btn-secondary"}`}
      style={{ x: springX, y: springY }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {children}
    </motion.a>
  );
};

export default Home;
